<div *ngIf="isVisible">
    <div class="content" role="heading" aria-level="1">

        <head>
            <title>Call Accounting Portal</title>
            <meta http-equiv="X-UA-Compatible" content="IE=edge" />
            <meta name="viewport" content="width=device-width, initial-scale=1">
            <meta http-equiv="X-UA-Compatible" content="IE=edge" />
            <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
            <script type="application/x-javascript">
                addEventListener("load", function() {
                    setTimeout(hideURLbar, 0);
                }, false);

                function hideURLbar() {
                    window.scrollTo(0, 1);
                }
            </script>
        </head>

        <body oncontextmenu="return false;">
            <form name="antiform">
                <div class="page-container">
                    <div class="left-content">  
                        <a alt="SideBar-Menu"></a>                 
                        <div class="mother-grid-inner">
                            <div class="header-main" style="background-color: #ffffff;">
                                <div class="header-left">
                                    <div class="logo-name">
                                        <a routerLink="Home">
                                            <img alt="AccentureLogo" src="../assets/img/AccentureLogo.png" style="margin-top:-2%;width: 100%;" />
                                        </a>
                                    </div>
                                    <!--search-box-->
                                    <!--//end-search-box-->
                                    <div class="clearfix"> </div>
                                </div>
                                <div class="header-right">
                                    <div class="profile_details_left">
                                        <!--notifications of menu start -->
                                        <ul class="nofitications-dropdown" style="margin-right:-100%;">

                                            <li class="dropdown head-dpdn">
                                                <a routerLink="#" class="dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
                                                    <label style="font-size: 25px; font-weight: bold; color: #7500c0; margin-left: -80%;">
                                                        CALL ACCOUNTING PORTAL
                                                    </label>
                                                </a>
                                            </li>
                                            <li>
                                                <a routerLink="OnlineSupport">
                                                    <img alt="OnlineSupport" src="../assets/img/livechat4.png" class="img-rec blink" title="Online Support" style="width: 100px; height: 80px; margin-top: -8%; margin-left: -30%; margin-bottom: -15%;">
                                                </a>
                                            </li>

                                            <li class="dropdown head-dpdn">
                                                <a routerLink="#" class="dropdown-toggle" data-toggle="dropdown" aria-expanded="false" style="margin-left:40%;" aria-label="Dropdown">
                                                </a>
                                            </li>
                                        </ul>
                                        <div class="clearfix"> </div>
                                    </div>
                                    <div class="profile_details">
                                        <ul>
                                            <li class="dropdown profile_details_drop">
                                                <a routerLink="ProfilePicture" class="dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
                                                    <div class="profile_img">

                                                        <!-- <span class="profile-ava" *ngIf="ProfileImage">
                                                            <img alt="" src="{{ProfilePicURL}}" class="img-circle"
                                                                style="width:45px;height:45px;">
                                                        </span> -->
                                                        <span class="profile-ava" *ngIf="ProfileImage">
                                                            <img alt="Profile" src="assets/img/People_Circle.PNG" class="img-circle"
                                                                style="width:45px;height:45px;">
                                                        </span>
                                                        <span *ngIf="EmptyImage">
                                                            <img alt="EmptyProfile" src="assets/img/People_Circle.PNG"
                                                                class="img-circle" style="width:40px;height:40px;">
                                                        </span>
                                                        <div class="user-name" style="color: #000000;">
                                                            <p>{{LoggedInEnterpriseId}}&nbsp;</p>

                                                        </div>
                                                        <i class="fa fa-angle-down lnr"></i>
                                                        <i class="fa fa-angle-up lnr"></i>
                                                        <div class="clearfix"></div>
                                                    </div>
                                                </a>
                                                <ul class="dropdown-menu drp-mnu">

                                                    <li>
                                                        <a (click)="LogOff()" target="_self" style="cursor:pointer" class="fa fa-sign-out" id="Logout">
                                                            <span style="font-family:  Helvetica Neue,Helvetica,Arial,sans-serif;">Log Out</span>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </li>
                                        </ul>
                                    </div>
                                    <!-- <div class="clearfix"> </div> -->
                                </div>
                                <!-- <div class="clearfix"> </div> -->
                            </div>
                            <!-- /script-for sticky-nav -->
                            <!--inner block start here-->
                            <div class="inner-block" ng-view style="min-height: 83vw; background: linear-gradient(141deg, #fafafa 20%, #fafafa 65%);">
                                <router-outlet></router-outlet>
                            </div>
                            <!-- Footer -->
                            <footer class="copyrights" align="center" style="background-color:#fafafa; display:block; position:fixed;bottom:0; width:96%;" id="foot">
                                <div align="left" style="margin-left:50px;">
                                    &nbsp; <a style="font-size: 1em; font-weight: bold;" class="footer_Content" href="https://in.accenture.com/protectingaccenture/data-security/5422-2/" target="_blank">Privacy Policy</a> &nbsp;&nbsp; <a style="font-size: 1em; font-weight: bold;"
                                        class="footer_Content" href="https://www.accenture.com/us-en/company-cookies-similar-technology" target="_blank">Cookie Policy</a> &nbsp;&nbsp;
                                    <a style="font-size: 1em; font-weight: bold;" class="footer_Content" routerLink="/TermsConditions">Terms of Use</a>
                                </div>
                                <div align="right">
                                    <p style="margin-top:-20px;color:black; font-size: 1em; font-weight: bold;margin-right:100px;">
                                        Copyright © {{this.CopyrightYear}} Accenture. All Rights Reserved. Accenture Highly Confidential. For Internal Use Only.</p>
                                </div>
                            </footer>
                        </div>
                    </div>
                    <!--slider menu-->
                    <div class="sidebar-menu" style="position:fixed;background: #fafafa;" id="scroll_navigation">
                        <div class="logo">
                            <a class="sidebar-icon" style="background: #000000; "> <span class="fa fa-bars"></span> </a>
                            <a routerLink="#" aria-label="Menu">
                                <span id="logo"></span>
                            </a>
                        </div>
                        <div class="menu">
                            <ul id="menu">
                                <li id="menu-home"><a routerLink="Home" title="Home"><i
                                            class="fa fa-home"></i><span>Home</span></a></li>
                                <li id="menu-profile">
                                    <a routerLink="Profile" title="Profile"><i
                                            class="fa fa-user"></i><span>Profile</span><span class="fa fa-angle-right"
                                            style="float: right"></span></a>
                                </li>
                                <li *ngIf="IsConfig">
                                    <a routerLink="#" title="Config"><i class="fa fa-cogs"></i><span>Config</span><span
                                            class="fa fa-angle-right" style="float: right"></span></a>
                                    <ul style="z-index:3500;" class="dropdown-content">
                                        <li><a routerLink="Gateway" title="Gateway">Gateway</a></li>
                                        <li><a routerLink="CallRates" class="" title="Call Rates">Call Rates</a></li>
                                        <li><a routerLink="CallRules" title="Call Rules">Call Rules</a></li>
                                        <li><a routerLink="Project" title="Project/Project Member Assignment">Project</a>
                                        </li>
                                        <li><a routerLink="Device" title="Device">Device</a></li>
                                        <li><a routerLink="Telco" title="Telco">Telco</a></li>
                                        <li><a routerLink="Destination" title="Destination">Destination</a></li>
                                        <li><a routerLink="CurrencyConversion" title="Currency Conversion">Currency
                                                Conversion</a></li>
                                        <li><a routerLink="CountryCodeConfiguration" title="Country Code Configuration">Country Code Configuration</a></li>
                                        <li><a routerLink="CAPMap" title="Common Area Phone Mapping">Common Area Phone
                                                Mapping</a></li>
                                        <li><a routerLink="DailInConference" title="Dial In Conference Call Mapping">Dial In
                                                Conference Call Mapping</a></li>
                                        <li *ngIf="IsSchedulerReport"><a routerLink=# title="Schedule Reports">Schedule Reports</a>
                                            <ul id="menu-academico-sub" style="z-index:3500;width: 200px;" class="dropdown-content">
                                                <li><a routerLink="RecoverReportsScheduler" title="Recovery Reports">Recovery Reports</a></li>
                                                <li><a routerLink="SummaryReportsScheduler" title="Summary Reports">Summary Reports</a></li>
                                            </ul>
                                        </li>
                                        <li><a routerLink="ShortCode" title="Short Code">
                                            Short Code
                                        </a></li>
                                        <!-- <li><a routerLink="Source" title="Source">Source</a></li> -->

                                    </ul>
                                </li>
                                <li id="menu-comunicacao" *ngIf="IsAdmin">
                                    <a routerLink="#" title="Admin"><i
                                            class="fa fa-users nav_icon"></i><span>Admin</span><span
                                            class="fa fa-angle-right" style="float: right"></span></a>
                                    <ul id="menu-comunicacao-sub" class="dropdown-content">
                                        <li><a class="" routerLink="AdminFeedBkSuggtn" title="Suggestion and Feedback">Suggestion and Feedback</a></li>
                                        <li><a class="" routerLink="ManageAccess" title="Manage Access">Manage Access</a></li>
                                    </ul>
                                </li>
                                <li id="menu-academico1" *ngIf="IsReports">
                                    <a routerLink="#" title="Reports"><i
                                            class="fa fa-bar-chart"></i><span>Reports</span><span
                                            class="fa fa-angle-right" style="float: right"></span></a>
                                    <ul id="menu-academico-sub1" class="dropdown-content">
                                        <li><a class="" routerLink="Reports" title="Recovery Reports">Recovery
                                                Reports</a>
                                        </li>
                                        <li><a class="" routerLink="SummaryReports" title="Summary Reports">Summary
                                                Reports</a></li>
                                    </ul>
                                </li>
                                <li id="menu-academico2" *ngIf="IsAuthcode">
                                    <a routerLink="#" title="Authcode Details">
                                        <i class="fa fa-black-tie"></i><span>
                                            Authcode Details
                                        </span><span class="fa fa-angle-right" style="float: right"></span>
                                    </a>
                                    <ul id="menu-academico-sub2" style="z-index:1000" class="dropdown-content">
                                        <li><a class="" routerLink="AuthorizationLevel" title="Add Authorization Levels">Add Authorization Levels</a></li>
                                        <li><a class="" routerLink="ActivateAuthRequests" title="Activate Authcode Requests">Activate Authcode Requests</a></li>
                                        <li><a class="" routerLink="DeActivateAuthRequests" title="DeActivate Authcode Requests">DeActivate Authcode Requests</a>
                                        </li>
                                    </ul>
                                </li>
                                <li id="menu-academico3" *ngIf="IsPay">
                                    <a routerLink="#" title="Requisition to Pay"><i
                                            class="fa fa-sort-amount-desc"></i><span>Requisition to Pay</span><span
                                            class="fa fa-angle-right" style="float: right"></span></a>
                                    <ul id="menu-academico-sub3" style="z-index:1000" class="dropdown-content">
                                        <li><a class="" routerLink="Leavers" title="Leavers">Leavers</a></li>
                                        <li><a class="" routerLink="RetaggingOfCalls" title="Retagging Of Calls">Retagging
                                                Of Calls</a></li>
                                    </ul>
                                </li>
                                <!-- <li id="menu-academico" *ngIf="IsEngineer">
                                    <a routerLink="CallsForVerification" title="Calls For Verification"><i class="fa fa-user-plus"></i><span>Calls For Verification</span><span class="fa fa-angle-right" style="float: right"></span></a>
                                </li> -->
                                <li id="menu-academico4">
                                    <a routerLink="#" title="Help"><i
                                            class="fa fa-file-image-o"></i><span>Help</span><span
                                            class="fa fa-angle-right" style="float: right"></span></a>
                                    <ul id="menu-academico-sub4" style="z-index:3500" class="dropdown-content">
                                        <!-- commented for vulnerability fix -->
                                         <li><a id="imgDownloadTemplate" class="" href="../assets/Templates/CallAccountingPortalUserManual.docx" target="_blank" title="User Manual" download>User Manual</a></li> 
                                         <!-- <li><a id="imgDownloadTemplate" class="" (click)="downloadUserManual()" target="_blank" title="User Manual" download>User Manual</a></li> -->

                                        <!-- Commented the DiallingInstructions and Prefixlistforfacilities link under Help tab based on the confirmation of Bussiness  -->
                                        <!-- <li><a class="" href="../assets/Templates/DiallingInstructions.docx"
                                                target="_blank" title="Dialling Instructions" download>Dialling Instructions</a>
                                        </li>
                                        <li><a class="" href="../assets/Templates/Prefixlistforfacilities.docx"
                                                target="_blank" title="Prefix list for facilities" download>Prefix list for facilities</a>
                                        </li> -->
                                        <li><a class="" routerLink="SuggestionsFeedback" title="Suggestion and Feedback">Suggestion and Feedback</a></li>
                                    </ul>
                                </li>
                                <li class="*ngIf" id="menu-academico" *ngIf="IsLogin">
                                    <a routerLink="Login" title="Login"><i
                                            class="fa fa-sign-in"></i><span>Login</span><span class="fa fa-angle-right"
                                            style="float: right"></span></a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="clearfix"> </div>
                </div>

                <script type="text/ng-template" id="warning-dialog.html">
                    <div data-backdrop="static" data-keyboard="false">
                        <br />
                        <div class="row">
                            <div class="col-sm-1" style="margin-left:3%;">
                                <img src="../assets/img/dialog_warning.png" />
                            </div>
                            <div class="col-sm-8" style="margin-left:4%;margin-top:2%;">
                                <h4>Your session is about to expire. Still there??</h4>
                            </div>

                        </div>
                        <div idle-countdown="countdown" ng-init="countdown=60" class="modal-body" style="height:130px;overflow-y:hidden">
                            <uib-progressbar max="60" value="60" animate="true" class="progress-striped active">Session Expires in {{countdown}} second(s).</uib-progressbar>


                            <button id="Confirm" type="submit" class="btn btn-default btn-group-sm Button1 " style="margin-left:35% ;margin-top:20px">
                            <span class="fa fa-power-off" aria-hidden="true">
                            </span> Log Out
                        </button>&nbsp;

                            <button id="cancelMod" type="submit" class="btn btn-default btn-group-sm cancel " style="margin-top:20px;">

                            <span class="fa fa-sign-in" aria-hidden="true">
                            </span> Continue
                        </button>
                        </div>
                    </div>
                </script>
                <script language="javascript" type="text/javascript">
                    var baseUrl = '@System.Configuration.ConfigurationManager.AppSettings["baseUrl"]';
                    var AuthUsr = '@System.Configuration.ConfigurationManager.AppSettings["AuthUsr"]'
                    var AuthPass = '@System.Configuration.ConfigurationManager.AppSettings["AuthPass"]'
                    var iv = '@System.Configuration.ConfigurationManager.AppSettings["iv"]';
                    var key = '@System.Configuration.ConfigurationManager.AppSettings["key"]';
                    var UserName = '@System.Configuration.ConfigurationManager.AppSettings["UserName"]';
                    var keyValue = '@System.Configuration.ConfigurationManager.AppSettings["keyValue"]';
                </script>

                <script type="text/javascript">
                    var selectedRecordCriteria = "All";
                    document.addEventListener("contextmenu", function(e) {
                        alert('The right click options are disabled for this window')
                        return false;
                    })
                    window.onpopstate = function(e) {
                        window.history.forward(1);
                    }
                </script>

            </form>
        </body>
    </div>
</div>
<div class="overlay" [ngStyle]="{'display':popUpModel}">
    <div class="modal" tabindex="-1" role="dialog">
        <div class="row">
            <div class="col-sm-1" style="margin-left:3%;">
                <img src="../assets/img/dialog_warning.png" />
            </div>
            <div class="col-sm-8" style="margin-left:4%;margin-top:2%;">
                <h4>Your session is about to expire. Still there??</h4>
            </div>
        </div>
        <div class="modal-body" style="height:130px;overflow-y:hidden">
            <p style="text-align:center"> {{idleState}} </p>

            <button id="Confirm" (click)="LogOff()" class="btn btn-default btn-group-sm Button1" style="margin-left:35% ;margin-top:20px">
                <span class="fa fa-power-off" aria-hidden="true"> </span> 
               Log Out
            </button>&nbsp;

            <button id="cancelMod" (click)="stay()" class="btn btn-default btn-group-sm cancel" style="margin-top:20px;">
                <span class="fa fa-sign-in" aria-hidden="true">
                </span> Continue
            </button>
        </div>
    </div>
</div>
<nf-modal></nf-modal>
<nf-alerts></nf-alerts>
<nf-toast></nf-toast> 
<div id="acn-alert" [attr.data-widgetid]="alertcomponent.WIDGET_ID" [attr.data-appid]="configData.APP_ID"></div>
<div id="acn-toast" [attr.data-widgetid]="toastcomponent.WIDGET_ID" [attr.data-appid]="configData.APP_ID"></div>
<div id="acn-modal" [attr.data-widgetid]="modalcomponent.WIDGET_ID" [attr.data-appid]="configData.APP_ID"></div> 